import { moneyFormat, timestamp2date } from '@/filters'

// Shared labelling for an order option (the "link to order" button picker AND the
// template order picker), so both read identically and never drift.

// The order's headline reference: its invoice number, or a #id fallback.
export const orderReference = order => order.invoice_nr || `#${order.id}`

// Who placed the order. The company leads where there is one (it is the customer
// on a B2B invoice); a guest checkout may carry neither name nor company, and the
// address the confirmation went to still identifies it.
export const orderPurchaser = order => {
    const purchaser = (order && order.purchaser) || {}
    return purchaser.company || purchaser.name || purchaser.email || ''
}

// The muted meta line: customer · date · total, so the agent can tell orders
// apart at a glance. The customer leads: a picker filtered to one member repeats
// it harmlessly, while an unfiltered one (the shop-wide link picker) is
// unreadable without it.
export const orderMeta = (order, dateFormat = 'yyyy-MM-dd') => {
    const date = order.created_at ? timestamp2date(order.created_at, dateFormat) : ''
    const total = (order.grand_total !== null && order.grand_total !== undefined)
        ? moneyFormat(order.grand_total, order.currency || 'EUR')
        : ''
    return [orderPurchaser(order), date, total].filter(Boolean).join(' · ')
}
